import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { debounce, map } from 'lodash-es';
import { productCategories, inputType } from '../constants';
import Input from './Input';
import { getUrlParam } from '../util';

function ProductAddModal(props) {
	const {
		modalParams = {},
		isOpen,
		onRequestClose,
		onAfterClose,
		onSave,
	} = props;

	const [name, setName] = useState(null);
	const [description, setDescription] = useState(null);
	const [type, setType] = useState(0);

	const { category } = modalParams;

	const onNameChanged = debounce((e) => {
		e.stopPropagation();
		setName(e.target.value);
	}, 200);

	const onDescriptionChanged = debounce((e) => {
		e.stopPropagation();
		setDescription(e.target.value);
	}, 200);

	const onTypeChanged = debounce((e) => {
		e.stopPropagation();
		setType(e.target.value);
	}, 200);

	const onSaveClicked = () => {
		const bookingId = getUrlParam('bookingId');

		onNameChanged.flush();
		onDescriptionChanged.flush();
		onTypeChanged.flush();

		const payload = {
			bookingId,
			type: category ? category.type : type,
			name,
			description,
		};

		onSave(payload);
	};

	const categories = map(
		Object.keys(productCategories),
		(x) => productCategories[x],
	);

	return (
		<ReactModal
			isOpen={isOpen}
			onRequestClose={onRequestClose}
			ariaHideApp={false}
			onAfterClose={onAfterClose}
		>
			<h2 className="margin-bottom-20">Dodaj Proizvod</h2>
			<div>
				<div className="input-wrap">
					<label htmlFor="category">Kategorija</label>
					<select
						id="category"
						disabled={category}
						onChange={onTypeChanged}
						defaultValue={
							category?.type ?? productCategories.bijelo
						}
					>
						{map(categories, (x) => (
							<option key={x.type} value={x.type}>
								{x.label}
							</option>
						))}
					</select>
				</div>
				<div>
					<Input
						id={'name'}
						type={inputType.text}
						label={'Ime Proizvoda'}
						placeholder={'Unesite ime proizvoda'}
						onChange={onNameChanged}
					/>
				</div>
				<div>
					<Input
						id={'description'}
						type={inputType.textarea}
						label={'O Proizvodu'}
						placeholder={
							'(npr. Godina berbe, Kategorija po ostatku šećera, Vrijeme odležavanja, Metoda proizvodnje itd.)'
						}
						style={{ height: '150px' }}
						onChange={onDescriptionChanged}
					/>
				</div>

				<button type="button" onClick={onSaveClicked}>
					Spremi
				</button>
				<button
					type="button"
					className="close-button"
					onClick={onRequestClose}
				>
					<svg
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M15 15L1 1"
							stroke="white"
							strokeWidth="1.5"
							strokeLinecap="round"
						/>
						<path
							d="M1 15L15 1"
							stroke="white"
							strokeWidth="1.5"
							strokeLinecap="round"
						/>
					</svg>
				</button>
			</div>
		</ReactModal>
	);
}

export default ProductAddModal;
